// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-theme="Dark"] input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(100%);
}

[data-theme="Dark"] input[type="datetime-local"]::-webkit-calendar-picker-indicator {
    filter: invert(100%);
}

input[type="datetime-local"] {
    margin-bottom: 5px;
}

input[type="date"]:required:is(:empty),
input[type="datetime-local"]:required:is(:empty) {
   outline: none;
}


input[type="date"]:required:invalid,
input[type="datetime-local"]:required:invalid {
   outline: 2px solid var(--required);
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLInputs/ECLDatePicker/ECLDatePicker.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;GAEG,aAAa;AAChB;;;AAGA;;GAEG,kCAAkC;AACrC","sourcesContent":["[data-theme=\"Dark\"] input[type=\"date\"]::-webkit-calendar-picker-indicator {\r\n    filter: invert(100%);\r\n}\r\n\r\n[data-theme=\"Dark\"] input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\r\n    filter: invert(100%);\r\n}\r\n\r\ninput[type=\"datetime-local\"] {\r\n    margin-bottom: 5px;\r\n}\r\n\r\ninput[type=\"date\"]:required:is(:empty),\r\ninput[type=\"datetime-local\"]:required:is(:empty) {\r\n   outline: none;\r\n}\r\n\r\n\r\ninput[type=\"date\"]:required:invalid,\r\ninput[type=\"datetime-local\"]:required:invalid {\r\n   outline: 2px solid var(--required);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
